// extracted by mini-css-extract-plugin
module.exports = {"root":"marquee-module--root--p_yJo","stroke":"marquee-module--stroke--3Hcte","inner":"marquee-module--inner--2OVF0","marquee":"marquee-module--marquee--1R4MD"};